export default __webpack_public_path__ + "static/pf-tree-858f5bd504bc31379f00aa6442e7900b.svg";